export var debounce = function (func, wait) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(null, args);
        }, wait);
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/lib/debounce.tsx
// module id = 1196
// module chunks = 0